export default __webpack_public_path__ + "static/media/galano-grotesque-alt-bold.84af6094.woff";